module.exports = __webpack_public_path__ + "img/banner_1.d8d60de8.jpg";